// pages/FormViewerPage/sections/SimpleEmbedBody.tsx — Body form lead-only (nama + WA saja)
import React from 'react';
import CustomerInfoFields from '../components/CustomerInfoFields';
import SpinnerIcon from '../../../components/icons/SpinnerIcon';
import WhatsappFillIcon from '../../../components/icons/WhatsappFillIcon';
import TagIcon from '../../../components/icons/TagIcon';
import ExclamationTriangleIcon from '../../../components/icons/ExclamationTriangleIcon';
import { getAnimationClasses } from '../components/FadeInBlock';
import { HerbalShippingClaimCard } from '../components/HerbalShippingClaimCard';
import type { FormViewerBodyProps } from './FormViewerBody/types';

export const SimpleEmbedBody: React.FC<FormViewerBodyProps> = ({
    hook, form, customerData, fieldErrors, addressData, setAddressData,
    getFlatRegionKey, EXCLUDED_PROVINCES, forceShowPostalCode,
    handleCustomerDataChange, handleWhatsappChange, handleSubmit,
}) => {
    const isSubmitting = hook.isSubmitting;
    const submission = hook.submission;
    const herbalClaimMode = hook.herbalClaimMode || 'wa';
    const setHerbalClaimMode = hook.setHerbalClaimMode;

    return (
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="w-full relative">
            <div className="space-y-3.5 p-1 text-slate-900 dark:text-slate-100">
                <CustomerInfoFields
                    form={form}
                    customerData={customerData}
                    fieldErrors={fieldErrors}
                    addressData={addressData}
                    onAddressDataChange={setAddressData}
                    onCustomerDataChange={handleCustomerDataChange}
                    onWhatsappChange={handleWhatsappChange}
                    blockSpacingClass=""
                    getFlatRegionKey={getFlatRegionKey}
                    EXCLUDED_PROVINCES={EXCLUDED_PROVINCES}
                    forceShowPostalCode={forceShowPostalCode}
                    isSimpleEmbed={true}
                />
                <HerbalShippingClaimCard
                    form={form}
                    claimMode={herbalClaimMode}
                    onClaimModeChange={setHerbalClaimMode}
                    addressData={addressData}
                    onAddressChange={setAddressData}
                    fieldErrors={fieldErrors}
                />
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={'w-full bg-emerald-700 hover:bg-emerald-800 text-white font-bold rounded-xl disabled:bg-emerald-400 disabled:cursor-not-allowed flex items-center justify-center p-3.5 text-base transition-all shadow-md hover:shadow-lg ' + (form.ctaSettings?.animationEnabled ? getAnimationClasses(form.ctaSettings?.animationType) : '')}
                    style={form.ctaSettings?.buttonColor ? { backgroundColor: form.ctaSettings.buttonColor } : {}}>
                    {isSubmitting ? (
                        <SpinnerIcon className="w-5 h-5 animate-spin" />
                    ) : (
                        <span className="flex items-center justify-center gap-2">
                            {herbalClaimMode === 'claim_ongkir' ? (
                                <>
                                    <TagIcon className="w-5 h-5" />
                                    <span>Kirim & Ambil Potongan Ongkir</span>
                                </>
                            ) : (
                                <>
                                    {form.ctaSettings?.buttonIcon ? (
                                        <span className="text-lg leading-none">{form.ctaSettings.buttonIcon}</span>
                                    ) : (
                                        <WhatsappFillIcon className="w-5 h-5" />
                                    )}
                                    <span>{form.ctaSettings?.mainText || 'Lanjut Chat WhatsApp CS'}</span>
                                </>
                            )}
                        </span>
                    )}
                </button>
                {submission?.error && (
                    <div className={'p-2.5 rounded-lg text-xs flex items-center gap-1.5 ' + (submission.retrying ? 'bg-amber-50 dark:bg-amber-900/30 border border-amber-200 text-amber-700' : 'bg-red-50 dark:bg-red-900/30 border border-red-200 text-red-700')}>
                        {submission.retrying ? <SpinnerIcon className="w-3.5 h-3.5 animate-spin shrink-0" /> : <ExclamationTriangleIcon className="w-3.5 h-3.5 shrink-0" />}<span>{submission.error}</span>
                    </div>
                )}
            </div>
        </form>
    );
};
